exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-striped>tbody>tr:nth-child(odd)>td,\n.table-striped>tbody>tr:nth-child(odd)>th {\n   /* background-color:  rgba(44, 191, 217, 0.151); */\n   background-color: rgba(185, 0, 0, 0.123);\n }\n\n .table-hover tbody tr:hover td, .table-hover tbody tr:hover th {\n  background-color:  rgba(44, 191, 217, 1);\n  color: white;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/usr/clienti.qmedical/src/app/shared/base-table.css
// module id = ../../../../../src/app/shared/base-table.css
// module chunks = main